import { createRoot } from 'react-dom/client';
import React from 'react';
import { App } from '~/components/App';
import { store } from '~/store/store';
import { sentryInit } from '~/lib/sentry';
import { profilerInit } from '~/lib/profiler';

await store.getActions().features.loadFeatures();
profilerInit();
sentryInit();

const container = document.getElementById('root')!;
const root = createRoot(container!);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
